<template>
  <section class="page-rule">
    <div
      class="content-wrap"
      ref="contentBScrollWrap">
      <div class="_container">
          <div class="rule-box" >
            <div class="rule-content" v-html="rule"></div>
            <!-- <img class="rule-content" src="../../assets/rule/rule_content.png" alt=""> -->
          </div>
      </div>
      <img class="btn-back" @click="goBack" src="../../assets/rule/btn_back.png" alt="">
    </div>
    <!--  something-->
    <!--render 组件，如需修改请查看[按住ctrl即可访问](https://github.com/vuejs/jsx) -->
  </section>
</template>
<script>

export default {
  name: 'rule-page',
  components: {},
  data() {
    return {
      rule: this.$store.state.activity.info.rule
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
    })
  },
  async mounted() {},
  async created() {
    this.$stat({ event: 'page_rule' }) // 上报事件
    this.$loading.show()
    // eslint-disable-next-line sonarjs/no-duplicate-string
    await this.$store.dispatch('activity/getAct')
    this.$loading.hide()
    // this.popUpBox()
  },
  methods: {
    goBack() {
      this.$stat({ event: 'rule_btn_back' }) // 上报事件
      this.$router.push('choose')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/base/_effect.scss';
.page-rule {
  .p_center{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .content-wrap{
    flex: 1;
    overflow: hidden;
    min-height: 1700px;
    ._container {
      position: relative;
      background-image: url(../../assets/home/bg.png);
      background-size: 100%;
      width: 750px;
      min-height: 1700px;
      .rule-box{
        background-image: url(../../assets/rule/rule_box.png);
        background-size: 100%;
        width: 670px;
        height: 1435px;
        border-radius: 20px;
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        .rule-content{
          width: 620px;
          height: 1260px;
          display: block;
          margin: 130px auto;
          overflow: scroll;
        }
      }
    }
    .btn-back{
      width: 388px;
      height: 95px;
      position: absolute;
      top: 1570px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
